export default __webpack_public_path__ + "static/banner-digital-is-the-new-cash-8bae5b6b277b0aea2eb6132b92d6b073.jpg";